import { render, staticRenderFns } from "./LayoutFuncionario.vue?vue&type=template&id=630d4216&scoped=true&"
import script from "./LayoutFuncionario.vue?vue&type=script&lang=js&"
export * from "./LayoutFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFuncionario.vue?vue&type=style&index=0&id=630d4216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d4216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContent,VRow})
